import type { Challenge } from '@dialogue/active-minutes'
import { convertMetricToLocalUnit } from '../general/helpers'

interface CategorizedChallenges {
  joined: Challenge[]
  newAndUpcoming: Challenge[]
}

export function categorizeChallenges(challenges: Challenge[] = []): CategorizedChallenges {
  const categorized: { joined: Challenge[]; newAndUpcoming: Challenge[] } = {
    joined: [],
    newAndUpcoming: [],
  }

  challenges.forEach((challenge) => {
    if (challenge.joined_at) {
      categorized.joined.push(challenge)
    } else {
      categorized.newAndUpcoming.push(challenge)
    }
  })

  return categorized
}

export const cleanupMetricValue = (initialValue: number, metric: string): string => {
  const value = convertMetricToLocalUnit(initialValue, metric)

  // @ts-expect-error FIXME: types provided are not compatible with the code here
  let fixedMetric: string = +parseFloat(value).toFixed(2)
  const decimals = fixedMetric.toString().split('.')[1]

  if (decimals && decimals.length === 1) {
    fixedMetric = `${fixedMetric}0`
  }

  return fixedMetric.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
